import { InjectionToken } from '@angular/core';

/**
 * Tenant/association display name for storefront admin screens (e.g. the
 * Store settings page subtitle: "{orgName} · storefront configuration.").
 * Each app adapts its own tenant-settings source (mirrors STOREFRONT_TIMEZONE).
 */
export interface StorefrontTenantProvider {
  getOrgName(): string;
  /**
   * Resolves the absolute URL of the customer-facing storefront (the member
   * portal's `/store` route) for this tenant, or null when there is no usable
   * address — the lookup failed, or the environment can't serve per-tenant
   * origins at all. Null means "don't offer the link", never "retry later":
   * the store resolves its tenant from the host, so there is no shared-host
   * address to fall back to. Optional — only the admin Store settings page's
   * "View storefront" link needs it.
   */
  getStorefrontUrl?(): Promise<string | null>;
}

export const STOREFRONT_TENANT = new InjectionToken<StorefrontTenantProvider>(
  'STOREFRONT_TENANT',
  { providedIn: 'root', factory: () => ({ getOrgName: () => '' }) },
);
